import { render, staticRenderFns } from "./ProductAddOld.vue?vue&type=template&id=100c3d42&"
import script from "./ProductAddOld.vue?vue&type=script&lang=js&"
export * from "./ProductAddOld.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddOld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports